import React from "react";
import {PowerBiLossAnalysisView } from "./powerbi-loss-analysis-view";
export const PowerBiLossAnalysisController = (props) => {
  return (
    <>
      <PowerBiLossAnalysisView {...props} />
    </>
  );
};
